var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', [_c('v-content', [_c('router-view')], 1), _c('v-snackbar', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "accent",
            "text": ""
          },
          on: {
            "click": function click($event) {
              return _vm.closeSnackBar();
            }
          }
        }, 'v-btn', attrs, false), [_vm._v(" dismiss ")])];
      }
    }]),
    model: {
      value: _vm.snackBar.show,
      callback: function callback($$v) {
        _vm.$set(_vm.snackBar, "show", $$v);
      },
      expression: "snackBar.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.snackBar.message) + " ")]), _c('v-dialog', {
    attrs: {
      "width": "680",
      "persistent": "",
      "content-class": "unsaved-changes-dialog"
    },
    model: {
      value: _vm.unsavedChangesModal,
      callback: function callback($$v) {
        _vm.unsavedChangesModal = $$v;
      },
      expression: "unsavedChangesModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline pr-3 py-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('unsaved_changes_title')) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancelLeave
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticClass: "py-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('unsaved_changes_description'))), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.$t('unsaved_changes_description_confirm')) + " ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.leaveWithoutPublishing
    }
  }, [_vm._v(_vm._s(_vm.$t('leave_without_publishing')))]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.publishingFromModal
    },
    on: {
      "click": _vm.publishAndLeave
    }
  }, [_vm._v(_vm._s(_vm.$t('publish_changes')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }